import React from "react";
import { Checkbox, FlatButton } from "material-ui";
import ClickToSelect from "@mapbox/react-click-to-select";

import BaseOverlay from "./partials/overlays/base.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import InfoNotice from "./partials/info-notice.jsx";
import LinkLike from "./partials/link-like.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketActions from "../actions/EventBucketActions";
import EventBucketStore from "../stores/EventBucketStore";

class EventBucketEverywhere extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.close = this.close.bind(this);
  }

  static getStores() {
    return [EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      pre: {
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontFamily: "monospace",
        marginTop: "1em",
        display: "block",
        minHeight: 20
      },
      widgetHeader: {
        margin: "1em 0"
      }
    };
  }

  close() {
    this.context.router.push(
      `/event_buckets/${this.props.params.eventBucketId}/settings`
    );
  }

  render() {
    let styles = this.getStyles(),
      bucket = this.props.getEventBucketById(this.props.params.eventBucketId);

    let query =
      this.state.defaultPage === "schedule"
        ? `?viewMode=${this.state.defaultViewMode}`
        : "";
    let path = this.state.defaultPage;

    return (
      <BaseOverlay
        title={"Eventive Everywhere"}
        hideTitleAndFooterBorders={true}
        useMuiDefaultStyle={true}
        openImmediately={true}
        actions={[<FlatButton label={"Close"} onTouchTap={this.close} />]}
        modal={true}
        open={true}
        onRequestClose={this.close}
      >
        {!bucket ? (
          <WorkingIndicator fullPage={true} />
        ) : (
          <div>
            <InfoNotice style={{ marginBottom: 15, fontSize: 12 }}>
              Check out our{" "}
              <a
                href="https://help.eventive.org/integrations/eventive-everywhere/introduction-to-eventive-everywhere"
                target="_blank"
              >
                introduction to Eventive Everywhere
              </a>
              .
            </InfoNotice>
            To enable Eventive Everywhere on your site, first copy and paste the
            following block of code immediately <u>before</u> the closing{" "}
            <code>{"</body>"}</code> tag at the bottom of the page.
            <ClickToSelect>
              <pre style={styles.pre}>
                {`<script type="text/javascript" src="https://js.stripe.com/v3/"></script>\n<script type="text/javascript" src="${bucket.urls.root}loader.js"></script>`}
              </pre>
            </ClickToSelect>
            Then include as many of the following widgets as you'd like!
            <h4 style={styles.widgetHeader}>Order Tickets</h4>
            <div>
              <i>Recommended:</i> Fully functional Eventive "Order Tickets"
              button. Automatically updates when logged in to show already
              ordered tickets, available passes, etc.
            </div>
            <ClickToSelect>
              <pre style={styles.pre}>
                {`<div class="eventive-button" data-event="REPLACE_WITH_EVENT_ID"></div>`}
              </pre>
            </ClickToSelect>
            <h4 style={styles.widgetHeader}>Buy Passes</h4>
            <div>
              <i>Recommended:</i> Fully functional Eventive "Buy Pass" button.
              Automatically updates when logged in to show applicable pass
              discounts. <i>Note:</i> Use the pass bucket code (e.g.{" "}
              <code>vip_pass</code>), <i>not</i> the ID.
            </div>
            <ClickToSelect>
              <pre style={styles.pre}>
                {`<div class="eventive-button" data-pass-bucket="REPLACE_WITH_PASS_BUCKET_CODE" data-buy-label="Buy now" data-quantity="1" data-discount=""></div>`}
              </pre>
            </ClickToSelect>
            <h4 style={styles.widgetHeader}>Login widget</h4>
            <div>
              Indicates if the customer is currently logged in and offers the
              option to log in / out. Unstyled by default so it can be
              integrated with your design as desired.
            </div>
            <ClickToSelect>
              <pre style={styles.pre}>
                {`<div class="eventive-login"></div>`}
              </pre>
            </ClickToSelect>
            <h4 style={styles.widgetHeader}>
              [Advanced] Fully custom checkout dialog
            </h4>
            <div>
              If you have your own pre-styled "Order Tickets" button HTML, you
              can wrap it in the following snippet and when customers click the
              button, an Eventive checkout modal will appear, right on your
              site.{" "}
              <i>
                Note: Does not allow customers to use passes. For pass
                functionality, see "Order Tickets" above.
              </i>
            </div>
            <ClickToSelect>
              <pre style={styles.pre}>
                {`<div class="eventive-custom-button" data-event="REPLACE_WITH_EVENT_ID">\n    /* Your custom HTML goes here */\n</div>`}
              </pre>
            </ClickToSelect>
          </div>
        )}
      </BaseOverlay>
    );
  }
}

export default connectToStores(EventBucketEverywhere);



// WEBPACK FOOTER //
// ./src/app/components/event-bucket-everywhere.jsx